<template>
  <div>
    <qx-card title="上报费用" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      >
        <!-- <template slot="title-right">
          <span
            class="primary cur"
            v-if="index === 'oil'"
            @click="showAddDialog(index)"
            >添加</span
          >
        </template> -->
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type || $route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="22000022"
      :inFast="Boolean(id)"
      :handleRefresh="handleRefresh"
    />
  </div>
</template>

<script>
import {
  approveItemInfo,
} from 'api';
import {
  repostCostApproveDetail, // 获取详情
} from 'api/cost';
import {
  orderOverviewDetail,
} from 'api/operate';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
    handleRefresh: {
      type: Function,
      default: () => {},
    },
  },
  data () {
    return {
      orderId: '',
      loading: false,
      detailData: {
        base: {
          label: '订单信息',
          tableData: {
            title: [
              {
                prop: 'orderId',
                label: '订单号码',
              },
              {
                prop: 'dependTime',
                label: '发车时间',
              },
              {
                prop: 'sourceName',
                label: '线路名称',
              },
              {
                prop: 'carDriverMan',
                label: '司机信息',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        oil: {
          label: '油费',
          type: 'array',
          tableData: {
            title: [
              {
                prop: 'amount',
                label: '消费金额',
                unit: '元',
              },
              {
                prop: 'oilRise',
                label: '加油升数',
              },
              {
                prop: 'paymentWayName',
                label: '支付方式',
              },
              {
                prop: 'cardNo',
                label: '卡号',
              },
              {
                prop: 'oilProductName',
                label: '油站名称',
              },
              {
                prop: 'stateName',
                label: '状态',
              },
              {
                prop: 'remark',
                label: '备注',
              },
              {
                prop: 'fileUrl',
                label: '上传附件',
                type: 'img',
                isArray: true,
              },
            ],
            data: [],
            approveData: [],
          },
        },
        bridge: {
          label: '路桥费',
          type: 'array',
          tableData: {
            title: [
              {
                prop: 'amount',
                label: '消费金额',
                unit: '元',
              },
              {
                prop: 'paymentWayName',
                label: '支付方式',
              },
              {
                prop: 'cardNo',
                label: '卡号',
              },
              {
                prop: 'stateName',
                label: '状态',
              },
              {
                prop: 'remark',
                label: '备注',
              },
              {
                prop: 'fileUrl',
                label: '上传附件',
                type: 'img',
                isArray: true,
              },
            ],
            data: [],
            approveData: [],
          },
        },
        isFullOil: {
          label: '交车时是否满油',
          tableData: {
            title: [
              {
                prop: 'isFullOilName',
                label: '是否满油',
              },
            ],
            data: [],
            approveData: [],
          },
        },
        // other: {
        //   label: '其他费用',
        //   type: 'array',
        //   tableData: {
        //     title: [
        //       {
        //         prop: 'consumeFee',
        //         label: '消费金额',
        //       },
        //       {
        //         prop: 'priceUnit',
        //         label: '单价',
        //       },
        //       {
        //         prop: 'typeName',
        //         label: '类型',
        //       },
        //       {
        //         prop: 'consumeNum',
        //         label: '数量',
        //       },
        //       {
        //         prop: 'stateName',
        //         label: '状态',
        //       },
        //       {
        //         prop: 'remark',
        //         label: '备注',
        //       },
        //       {
        //         prop: 'fileUrl',
        //         label: '上传附件',
        //         type: 'img',
        //         isArray: true,
        //       },
        //     ],
        //     data: [

        //     ],
        //     approveData: [],
        //   },
        // },
        // meter: {
        //   label: '仪表盘公里数（温馨提示：本趟上报里程2,000.00km(空载里程：1,000.00km，载重里程：1,000.00km)）',
        //   tableData: {
        //     title: [
        //       {
        //         prop: 'startKm',
        //         label: '出车仪表公里数',
        //       },
        //       {
        //         prop: 'startKmUrlPath',
        //         label: '附件',
        //         type: 'img',
        //       },
        //       {
        //         prop: 'loadingKm',
        //         label: '装货仪表公里数',
        //       },
        //       {
        //         prop: 'loadingKmUrlPath',
        //         label: '附件',
        //         type: 'img',
        //       },
        //       {
        //         prop: 'unloadingKm',
        //         label: '卸货仪表公里数',
        //       },
        //       {
        //         prop: 'unloadingKmUrlPath',
        //         label: '附件',
        //         type: 'img',
        //       },
        //       {
        //         prop: 'endKm',
        //         label: '收车仪表公里数',
        //       },
        //       {
        //         prop: 'endKmUrlPath',
        //         label: '附件',
        //         type: 'img',
        //       },
        //       {
        //         prop: 'isFullOil',
        //         label: '是否满油',
        //       },
        //     ],
        //     data: {

        //     },
        //     approveData: {

        //     },
        //   },
        // },
        report: {
          label: '上报状态',
          tableData: {
            title: [
              {
                prop: 'loadMileage',
                label: '载重校准里程',
              },
              {
                prop: 'capacityLoadMileage',
                label: '空载校准里程',
              },
              {
                prop: 'stateName',
                label: '上报状态',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.orderId': function () {
      this.getData();
    },
  },
  methods: {
    showAddDialog (itemName) {
      console.log(itemName);
    },
    handleMeterNum ({ data, keys }) {
      keys.forEach((key) => {
        if (data[key]) {
          data[key] = (data[key] / 1000).toFixed(3) + 'KM';
        }
      });
    },
    handlePushImg (item, tar) {
      const fileUrl = [];
      Object.keys(item).forEach((key) => {
        if (key.startsWith('fileUrl') && key.endsWith('Path') && item[key]) {
          fileUrl.push(item[key]);
        }
      });
      item.fileUrl = fileUrl;
    },
    async getData () {
      if (this.$route.path !== '/manage/cost/report/approve/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const orderRes = await orderOverviewDetail({
        orderId: this.orderId || this.$route.query.orderId,
      });
      orderRes.carDriverMan = `${orderRes.carDriverMan}（${orderRes.carDriverPhone}）`;
      this.detailData.base.tableData.data = orderRes;
      const detailRes = await repostCostApproveDetail({
        orderId: this.orderId || this.$route.query.orderId,
        isEdit: 2,
      });
      this.loading = false;
      if (!detailRes.failed) {
        this.handleMeterNum({
          data: detailRes,
          keys: [
            'startKm', // 出车仪表公里数
            'loadingKm', // 装货仪表公里数
            'unloadingKm', // 卸货仪表公里数
            'endKm', // 收车仪表公里数
            'loadMileage', // 载重校准里程
            'capacityLoadMileage', // 空载校准里程
          ],
        });
        detailRes.isFullOil = detailRes.isFullOil === 0 ? '未满' : '已满';
        switch (detailRes.paymentWay) {
          case 1:
            detailRes.paymentWayName = '油卡';
            break;
          case 2:
            detailRes.paymentWayName = '现金';
            break;
          case 3:
            detailRes.paymentWayName = 'ETC卡';
            break;
          default:
            detailRes.paymentWayName = '';
            break;
        }
        if (detailRes.oilCostDataList && detailRes.oilCostDataList.length) {
          detailRes.oilCostDataList.forEach((item) => {
            this.handlePushImg(item);
            item.oilProductName = '--';
            switch (item.paymentWay) {
              case 1:
                item.oilProductName = '--';
                item.paymentWayName = '油卡';
                break;
              case 2:
                item.oilProductName = '--';
                item.paymentWayName = '现金';
                break;
              case 3:
                item.oilProductName = '--';
                item.paymentWayName = 'ETC卡';
                break;
              default:
                item.paymentWayName = '-';
                break;
            }
          });
        }
        this.detailData.oil.tableData.data = detailRes.oilCostDataList || [];
        if (detailRes.etcCostDataList && detailRes.etcCostDataList.length) {
          detailRes.etcCostDataList.forEach((item) => {
            this.handlePushImg(item);
          });
        }
        this.detailData.bridge.tableData.data = detailRes.etcCostDataList || [];
        detailRes.otherCostDataList.forEach((item) => {
          this.handlePushImg(item);
        });
        // this.detailData.other.tableData.data = detailRes.otherCostDataList;
        // this.detailData.meter.tableData.data = detailRes;
        this.detailData.report.tableData.data = detailRes;
        this.detailData.isFullOil.tableData.data = detailRes;
      }
    },
  },
  async mounted () {
    if (this.id) {
      const res = await approveItemInfo({
        busiId: this.id,
        busiCode: 22000022,
      });
      this.orderId = res.orderId;
    }
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
